import {
  ESGPoliciesSVG,
  FinancialStrengthSVG,
  OperationalSVG,
} from "@components/svgs";
import { BusinessMetricTypeId } from "@models/configuration/feature";
import {
  BusinessMetricCategories,
  BusinessMetricDTO,
} from "@models/platform-analysis/entities/steps/businessMetric";

export const BusinessMetricCategoriesConfigs: {
  key: keyof Pick<
    BusinessMetricCategories,
    "financialStrength" | "esg" | "operational"
  >;
  typeId: BusinessMetricTypeId;
  title: string;
  icon: JSX.Element;
  getCategoryData: (
    categories: BusinessMetricCategories,
  ) => BusinessMetricDTO[] | undefined;
}[] = [
  {
    key: "financialStrength",
    typeId: BusinessMetricTypeId.FinancialStrength,
    title: "Financial strength",
    icon: <FinancialStrengthSVG />,
    getCategoryData: (categories: BusinessMetricCategories) =>
      categories.financialStrength,
  },
  {
    key: "esg",
    typeId: BusinessMetricTypeId.Esg,
    title: "ESG Policies",
    icon: <ESGPoliciesSVG />,
    getCategoryData: (categories: BusinessMetricCategories) => categories.esg,
  },
  {
    key: "operational",
    typeId: BusinessMetricTypeId.Operational,
    title: "Operational",
    icon: <OperationalSVG />,
    getCategoryData: (categories: BusinessMetricCategories) =>
      categories.operational,
  },
];
